/* eslint-disable react/prop-types */
import React from 'react';
import { connect } from 'react-redux';
import { Formik } from 'formik';
import {
  FormGroup,
  Label,
  Input,
  Row,
  Col,
} from 'reactstrap';
import { Base64 } from 'js-base64';
import Switch from 'react-switch';

import { injectIntl } from 'react-intl';
import styled from 'styled-components';
import toastr from 'toastr';
import { Link } from 'react-router-dom';
import { FaImage, FaTrashAlt } from 'react-icons/fa';

import escapeChars from '../helpers/regex';
import { IMG_URL } from '../config';
import Loading from '../components/Loading';
import Content from '../components/layout/Content';
import FormError from '../components/formControls/FormError';
import SnipperButton from '../components/buttons/SpinnerButton';
import { getCategory, categoryUpdate, categoryUpdateWoutFile } from '../api/category';
import { updateProductWoutFile } from '../api/product';

const DeleteButton = styled(FaTrashAlt)`
  top: 0; 
  left: 20px;
  cursor: pointer;
`;

class CategoryDetail extends React.Component {
  constructor(props) {
    super(props);
    this.deleteHandlerProduct = this.deleteHandlerProduct.bind(this);
    this.deleteHandler = this.deleteHandler.bind(this);
    this.state = {
      loading: false,
      category: '',
      checked: false,
      imageUrl: '',
      masterUser: null,
    };
  }

  async componentDidMount() {
    const { match: { params: { categoryId } } } = this.props;
    const category = await getCategory(categoryId);
    const { user } = this.props;
    // const masterUser = user.isAdmin ? user.id : user.masterUserId;
    const masterUser = user && (user.masterUserId || user.id);
    let path = '';

    try {
      if (category.data.category.displayPicture) {
        path = `${IMG_URL}${Base64.encode(masterUser)}/images/q-${category.data.category.displayPicture}`;
      } else {
        path = null;
      }
    } catch (err) {
      console.error(err);
    }
    this.setState({
      category: category.data.category,
      masterUser,
      checked: category.data.category.isActive,
      imageUrl: path,
    });
  }

  async deleteHandler(category) {
    const { masterUser } = this.state;

    category.displayPicture = null;
    await categoryUpdateWoutFile(masterUser, category)
      .then((result) => {
        this.setState({ imageUrl: null });
        return result;
      }, (error) => {
        console.log('error', error);
        console.log(error.response);
        return error;
      }).catch((error) => {
        console.log('catch error', error);
        return error;
      });

    toastr.success('', 'Deleted');
  }

  async deleteHandlerProduct(product) {
    product.displayPicture = null;
    await updateProductWoutFile(product)
      .then((result) => {
        this.setState({ imageUrl: null });
        const imagefile = document.querySelector('#categoryImage');
        imagefile.value = '';
        return result;
      }, (error) => {
        console.log('error', error);
        console.log(error.response);
        return error;
      }).catch((error) => {
        console.log('catch error', error);
        return error;
      });

    toastr.success('', 'Deleted');
  }

  render() {
    const { intl } = this.props;
    const {
      loading, category, masterUser, checked, imageUrl,
    } = this.state;

    const categoryUpdatedText = intl.formatMessage({ id: 'categories.updated' });
    const categoryDetailText = intl.formatMessage({ id: 'categories.detail' });
    const categoryNameText = intl.formatMessage({ id: 'categories.name' });
    const categoryStatusText = intl.formatMessage({ id: 'categories.status' });
    const categoryImageText = intl.formatMessage({ id: 'categories.image' });
    const menuEditText = intl.formatMessage({ id: 'sidebar.menu.edit' });
    const tagGroupNameText = intl.formatMessage({ id: 'taggroup.name' });
    const imageScaleText = intl.formatMessage({ id: 'image.scale' });
    const editText = intl.formatMessage({ id: 'edit' });
    const productsText = intl.formatMessage({ id: 'products' });

    return (
      <Row>
        <Col>
          <Formik
            initialValues={
              {
                displayName: category && category.displayName,
              }
            }
            enableReinitialize
            onSubmit={async (submit) => {
              const formData = new FormData();
              const imagefile = document.querySelector('#categoryImage');
              if (imagefile.files[0] !== undefined) {
                formData.append('categoryImage', imagefile.files[0], escapeChars(imagefile.files[0].name));
              }
              formData.append('displayName', submit.displayName);
              formData.append('isActive', checked ? 1 : 0);

              formData.append('id', category.id);
              this.setState({ loading: true });
              const result = await categoryUpdate(masterUser, formData);
              if (result.error) {
                this.setState({ loading: false });
                imagefile.value = '';
                return toastr.error(result.error.response.data.error);
              }
              this.setState({ loading: false });
              imagefile.value = '';
              toastr.success('', categoryUpdatedText);
            }}
          >
            {({
              values,
              errors,
              handleChange,
              handleBlur,
              handleSubmit,
              setFieldValue,
              /* and other goodies */
            }) => (
              <Content
                  title={categoryDetailText}
                  breads={[{ to: '/panel/menu-edit', name: menuEditText }, { name: category && category.displayName }]}
                >
                  {
                    !category ? <Loading />
                      : (
                        <form onSubmit={handleSubmit} encType="multipart/form-data">
                          <FormGroup>
                            <Label for="displayName">{categoryNameText}</Label>
                            <Input
                              type="text"
                              name="displayName"
                              id="displayName"
                              placeholder={tagGroupNameText}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.displayName}
                            />
                            {errors.name && <FormError error={errors.name} />}
                          </FormGroup>
                          <FormGroup>
                            <p htmlFor="displayName">{categoryStatusText}</p>
                            <Switch
                              onChange={() => this.setState({ checked: !checked })}
                              checked={checked}
                              className="react-switch"
                            />
                            {errors.name && <FormError error={errors.name} />}
                          </FormGroup>
                          <FormGroup>
                            <Label for="categoryImage">{categoryImageText}</Label>
                            <Input
                              type="file"
                              name="categoryImage"
                              id="categoryImage"
                              onChange={(event) => {
                                this.setState({ imageUrl: URL.createObjectURL(event.currentTarget.files[0]) });
                                setFieldValue('categoryImage', event.currentTarget.files[0]);
                              }}
                            />
                            <div>
                              <small>{imageScaleText}</small>
                            </div>
                            <PreviewImg id="previewImage" src={imageUrl || ''} alt="" />

                            {imageUrl && <DeleteButton onClick={() => this.deleteHandler(category)} />}
                          </FormGroup>
                          <FormGroup>
                            <Label>{productsText}</Label>
                            <Row>
                              {
                                category.Products.map((product) => {
                                  let path;
                                  if (product.displayPicture) {
                                    path = `${IMG_URL}${Base64.encode(masterUser)}/images/q-${product.displayPicture}`;
                                  } else {
                                    path = null;
                                  }
                                  return (
                                    <Col md="3" key={product.id}>
                                      <CategoryWrapper to={`/panel/product/${product.id}`}>
                                        <ImageWrapper>
                                          {
                                            product.displayPicture
                                              ? <img width="100%" height="100%" src={path} alt="" />
                                              : <FaImage />
                                          }
                                        </ImageWrapper>
                                        <span>{product.displayName}</span>
                                      </CategoryWrapper>
                                    </Col>
                                  );
                                })
                              }
                            </Row>
                          </FormGroup>
                          <SnipperButton type="submit" loading={loading} text={editText} />
                        </form>
                      )
                  }
                </Content>
            )}
          </Formik>
        </Col>
      </Row>
    );
  }
}

const CategoryWrapper = styled(Link)`
  display: flex;
  min-height: 50px;
  background: #e8e8e8;
  padding: 10px;
  margin-bottom: 10px;
  color: #666666;
  text-decoration: none !important;
  :hover {
    color: #666666;
  }
`;

const ImageWrapper = styled.div`
  border: 1px dashed #aba5a5;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  border-radius: 3px;
  width:75px;
  height:75px;
`;

const PreviewImg = styled.img`
  margin-top: 20px;
  width: 200px;
`;

const mapStateToProps = (state) => ({ user: state.auth.user });

export default injectIntl(connect(mapStateToProps)(CategoryDetail));
